import React from 'react'
import NumberFormat  from 'react-number-format'
import JWT from 'expo-jwt';

export const getRFPUrl = (user, docNumber=null) =>{
  var date = new Date();
  date.setHours(date.getHours() + 2);
  let name = user.fullname.split(' ')
  //getAuthen
  let token = JWT.encode({ 
    username: user.username,
    firstName: name[0],
    lastName: name[1],
    email: user.email,
    departmentcode: user.mainDeptCode,
    subDepartmentcode: user.subDeptCode,
    exp: Math.floor(date / 1000),
    to:'DTGO_USER'
  }, process.env.REACT_APP_RFP_SECRET_KEY);
  let url = `${process.env.REACT_APP_RFP_SECRET_URL}?token=${token}`
  if(docNumber){
    url += `&propNo=${docNumber}`
  }
  return url
}

export const numberFormat = (value, allowNegative = false,decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}